import dynamic from "next/dynamic";

import type { Props as GenericArticleProps } from "./generic-article";
import type { Props as InfographicArticleProps } from "./infographic-article";
import type { Props as LiveArticleProps } from "./live-article";
import type { Props as LongReadArticleProps } from "./long-read-article";
import type { Props as MorningStudioArticleProps } from "./morning-studio-article";
import type { Props as NewsletterArticleProps } from "./newsletter-article";
import type { Props as OpinionArticleProps } from "./opinion-article";
import type { Props as PhotoEssayArticleProps } from "./photo-essay-article";
import type { Props as StyleArticleProps } from "./style-article";

export const DynamicStyleArticle = dynamic<StyleArticleProps>(() =>
  import("./style-article").then(module => module.StyleArticle),
);

export const DynamicGenericArticle = dynamic<GenericArticleProps>(() =>
  import("./generic-article").then(module => module.GenericArticle),
);

export const DynamicInfographicArticle = dynamic<InfographicArticleProps>(() =>
  import("./infographic-article").then(module => module.InfographicArticle),
);

export const DynamicLiveArticle = dynamic<LiveArticleProps>(() =>
  import("./live-article").then(module => module.LiveArticle),
);

export const DynamicLongReadArticle = dynamic<LongReadArticleProps>(() =>
  import("./long-read-article").then(module => module.LongReadArticle),
);

export const DynamicMorningStudioArticle = dynamic<MorningStudioArticleProps>(() =>
  import("./morning-studio-article").then(module => module.MorningStudioArticle),
);

export const DynamicNewsletterArticle = dynamic<NewsletterArticleProps>(() =>
  import("./newsletter-article").then(module => module.NewsletterArticle),
);

export const DynamicOpinionArticle = dynamic<OpinionArticleProps>(() =>
  import("./opinion-article").then(module => module.OpinionArticle),
);

export const DynamicPhotoEssayArticle = dynamic<PhotoEssayArticleProps>(() =>
  import("./photo-essay-article").then(module => module.PhotoEssayArticle),
);
